export default __webpack_public_path__ + "static/media/checklist.feed4f9e.png";